module.exports = __webpack_public_path__ + "img/qqhz.6273c72e.jpg";